const bodyType = [
  { label: "Athletic", value: "Athletic" },
  { label: "Average", value: "Average" },
  { label: "Few Extra Pounds", value: "Few Extra Pounds" },
  { label: "Muscular / Built", value: "Muscular / Built" },
  { label: "Overweight", value: "Overweight" },
  { label: "Petite", value: "Petite" },
  { label: "Skinny", value: "Skinny" },
];
const bodyTypeMale = [
  { label: "Athletic", value: "Athletic" },
  { label: "Average", value: "Average" },
  { label: "Few Extra Pounds", value: "Few Extra Pounds" },
  { label: "Muscular / Built", value: "Muscular / Built" },
  { label: "Overweight", value: "Overweight" },
  { label: "Skinny", value: "Skinny" },
];
const bodyTypeFemale = [
  { label: "Athletic", value: "Athletic" },
  { label: "Average", value: "Average" },
  { label: "Few Extra Pounds", value: "Few Extra Pounds" },
  { label: "Toned / Fit", value: "Toned / Fit" },
  { label: "Overweight", value: "Overweight" },
  { label: "Petite", value: "Petite" },
  { label: "Skinny", value: "Skinny" },
];
export { bodyType, bodyTypeFemale, bodyTypeMale };
